import { useCallback } from 'react';
import { trpc } from '~/api/trpc';
import { useBookingFlowStore } from '~/stores/booking-flow-store';

/**
 * Returns the scuid captured at the start of the funnel, so the booking is
 * attributed to the same session as the dataLayer events already sent.
 *
 * The store is usually populated by GTMProvider on the first analytics event.
 * If it is not, we fall back to asking the server what the scuid cookie on the
 * request was and cache that for the rest of the session.
 */
export const useScuid = () => {
    const trpcUtils = trpc.useUtils();

    return useCallback(async (): Promise<string | undefined> => {
        const { scuid, setScuid } = useBookingFlowStore.getState();
        if (scuid) return scuid;

        try {
            const { scuid: fetchedScuid } = await trpcUtils.publicUtilities.getScuid.fetch();
            setScuid(fetchedScuid ?? null);
            return fetchedScuid ?? undefined;
        } catch (e) {
            console.log('Failed to fetch scuid:', e);
            return undefined;
        }
    }, [trpcUtils]);
};
